import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Mouth_10 = ({ skinColours, lipColours }) => {
  const colour0 = lipColours.base;
  const colour1 = lipColours.shadow;
  const colour2 = lipColours.base;
  const colour3 = '#40332E';
  const colour4 = '#3B2E2A';
  const colour5 = '#342723';
  const colour6 = '#231A18';
  const colour7 = '#EC4845';
  const colour8 = '#F58E87';
  const colour9 = '#F37D79';
  const colour10 = '#F26767';
  const colour11 = '#FFFEF0';
  const colour12 = '#FFEFDA';
  const colour13 = '#F2D5B2';
  const colour14 = '#F8B2B3';
  const colour15 = lipColours.base;
  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M332.3,658.6c-2.2,11.3,6.1,41.3,34.3,63.9c19.3,15.5,73.4,8.3,80.8,1.3c9.7-9.2,31-49.9,23.8-71.6
		c-12.1-36.4,1.1-102.2-33.6-112.2c-6.8-2-25.6,7.4-34.3,4.8c-8.7-2.7-24.7-14.1-35.6-11.5C327.9,542.8,342.4,607.7,332.3,658.6z"
        />
        <path
          fill={colour1}
          d="M470.2,649.1c-6.5-22.8-4.5-55.3-10-79.1c-6.5,9.8-48.6-13.4-49.9-24.9c-2.7,0.3-5,0.3-7-0.3
		c-1.7-0.5-3.8-1.4-6.1-2.5c-7.7,4.1-50.9,51.2-56.3,24.4c-4.5,21.5-3.3,49.9-6.4,76.5c6.7,0.5,12,12.1,12,26.3
		c0,9.4-2.3,17.6-5.8,22.3c5.5,10.2,13.9,21.1,25.8,30.7c19.3,15.5,73.4,8.3,80.8,1.3c4.1-3.8,10.2-13.2,15.3-24.3
		C455,689.7,458,659.9,470.2,649.1z"
        />
        <path
          fill={colour2}
          d="M334,658.4c0-14.5,3-93.8,64.5-98.2c52.2-3.7,63.5,48.7,69.8,101c0.4,3.1-1.4,29.7-30,40.7
		c-22.3,8.6-47.9,6.4-76.1-7.3C352.2,689.6,334,666.9,334,658.4z"
        />
        <path
          fill={colour3}
          d="M335.9,657.6c0-14.1,2.9-91.2,62.7-95.5c50.7-3.6,61.8,47.4,67.9,98.1c0.4,3-1.4,26.6-29.2,37.3
		c-21.6,8.3-46.6,6.3-74-7.1C353.5,685.8,335.9,666,335.9,657.6z"
        />
        <path
          fill={colour4}
          d="M345.3,658.1c0-12,2.5-77.3,53.6-81c43.4-3.1,52.8,40.2,58,83.2c0.3,2.5-1.2,22.6-25,31.7
		c-18.5,7.1-39.8,5.3-63.2-6C360.5,682,345.3,665.2,345.3,658.1z"
        />
        <path
          fill={colour5}
          d="M354.9,665c0-9.3,2-60.2,44.4-63.1c35.9-2.4,43.7,31.3,48.1,64.8c0.3,2-1,17.6-20.7,24.7
		c-15.3,5.5-33,4.1-52.4-4.7C367.4,683.6,354.9,670.5,354.9,665z"
        />
        <path
          fill={colour6}
          d="M365.1,667.4c0-7.9,1.6-51,34.7-53.4c28.1-2,34.2,26.5,37.5,54.9c0.2,1.7-0.8,14.9-16.2,20.9
		c-12,4.7-25.8,3.5-40.9-4C374.8,683.1,365.1,672,365.1,667.4z"
        />
        <path
          fill={colour7}
          d="M345.3,675.2c0,0,7.9,10.2,15.3,13.8l9-32C369.6,657,352.1,660.2,345.3,675.2z"
        />
        <path
          fill={colour7}
          d="M457.7,683.8c0,0-5.2,8.6-15.9,12.9l-5.4-36.4C436.4,660.3,451.7,664.8,457.7,683.8z"
        />
        <path
          fill={colour8}
          d="M358.5,663.7c16.6-16,37.1-3.6,41-3.6c3.9,0,30.1-4.9,38.5,1.2c8.5,6.2,35.6,66.6,8.6,96.8
		c-32.3,36.1-82.5,13.8-91.2-9.9C345.6,720.8,345.9,675.9,358.5,663.7z"
        />
        <path
          fill={colour9}
          d="M439.2,662.3c2.8,5.7,4.5,12.8,4.5,20.5c0,18.7-10,33.9-22.3,33.9c-9.1,0-17-8.4-20.4-20.4
		c-2.1,7.4-6.7,13.1-13,14.8c-11.6,3.3-24.7-7.6-29.3-24.3c-4.6-16.7,2.9-27.6,14.5-30.9c0,0,0,0,0,0c-4.9,0.9-10,3.1-14.8,7.7
		c-12.7,12.2-14.7,58.4-4.7,85.8c8.6,23.7,62.3,46,94.6,10C474.3,730.5,448.8,672.4,439.2,662.3z"
        />
        <path
          fill={colour10}
          d="M439.7,662.9c17.5,32.7,18.6,108.7-39.3,96.9c-27.5-5.6-57-45.6-45.8-90.6c-9,17.2-9.5,56-0.7,80.2
		c8.6,23.7,62.3,46,94.6,10C473.8,731,449.7,674.5,439.7,662.9z"
        />
        <path
          fill={colour10}
          d="M400.2,672.9c1-5.1,2.8-9.7,5.2-13.5c-2.8,0.3-4.9,0.6-5.8,0.6c-1.7,0-6.7-2.4-13.1-3.7
		C392.3,658.6,397.3,664,400.2,672.9z"
        />
        <g>
          <path
            fill={colour7}
            d="M450.1,756.7c-32.3,36.1-86,13.7-94.6-10c-8.9-24.4-8.3-63.6,0.9-80.5c-10.7,15.1-11.9,57.5-2.5,83.2
			c8.6,23.7,62.3,46,94.6,10c1.9-2.2,3.6-4.5,4.9-6.9C452.4,753.9,451.3,755.3,450.1,756.7z"
          />
        </g>
        <path
          fill={colour11}
          d="M353.5,592.9c1.8-3.6,13.6-24.9,49.2-27.9c27.8-2.3,46.4,26.5,44.6,28.8c-1.4,1.8-18.5-9.2-44.7-8.7
		C377.1,585.6,351.2,597.5,353.5,592.9z"
        />
        <path
          fill={colour12}
          d="M437.9,578.9c4.4,5.8,6.6,10.9,6,11.9c-1.3,1.9-17.1-9.4-41.2-8.8c-23.5,0.5-47.3,12.6-45.2,7.9
		c0.7-1.4,2.7-5.7,6.9-10.5c-6.8,5.9-10,11.7-10.9,13.4c-2.3,4.6,23.5-7.3,49.1-7.8c26.2-0.5,43.3,10.5,44.7,8.7
		C448.2,592.7,444.7,585.8,437.9,578.9z"
        />
        <path
          fill={colour13}
          d="M354.7,593.9c6.2-7.8,20.4-20.4,48.4-22.6c21.4-1.7,37.6,13.4,44,22.6c0.1,0,0.2-0.1,0.2-0.1
		c1.8-2.3-17.3-32.2-45-29.9c-35.6,3-46.9,25.4-48.8,29C353.1,593.6,353.6,593.9,354.7,593.9z"
        />
        <path
          fill={colour14}
          d="M413.6,661.5c-0.1-0.6-1-0.9-2.1-0.8c-1.1,0.1-1.9,0.7-1.8,1.3c0.1,0.6,1,0.9,2.1,0.8
		C412.9,662.7,413.7,662.1,413.6,661.5z"
        />
        <path
          fill={colour14}
          d="M432.5,662.1c0.2-0.5-0.5-1.3-1.6-1.6c-1.1-0.3-2-0.2-2.2,0.4c-0.2,0.5,0.5,1.3,1.6,1.6
		C431.4,662.8,432.3,662.6,432.5,662.1z"
        />
        <path
          fill={colour14}
          d="M440.2,672.2c0.2-0.5-0.3-1.1-1.1-1.4c-0.8-0.3-1.5,0-1.7,0.5c-0.2,0.5,0.3,1.1,1.1,1.4
		C439.3,672.9,440,672.7,440.2,672.2z"
        />
        <path
          fill={colour9}
          d="M435.9,700c-0.2-0.5-0.9-0.7-1.7-0.5c-0.8,0.3-1.3,0.9-1.1,1.4c0.2,0.5,0.9,0.7,1.7,0.5
		C435.6,701.1,436.1,700.5,435.9,700z"
        />
        <path
          fill={colour9}
          d="M428.7,698.5c-0.2-0.5-0.9-0.7-1.7-0.5c-0.8,0.3-1.3,0.9-1.1,1.4c0.2,0.5,0.9,0.7,1.7,0.5
		C428.3,699.6,428.8,699,428.7,698.5z"
        />
        <path
          fill={colour9}
          d="M387.1,704.8c-0.2-0.5-0.9-0.7-1.7-0.5c-0.8,0.3-1.3,0.9-1.1,1.4c0.2,0.5,0.9,0.7,1.7,0.5
		C386.8,706,387.3,705.4,387.1,704.8z"
        />
        <path
          fill={colour9}
          d="M393.9,696c-0.2-0.5-0.9-0.7-1.7-0.5c-0.8,0.3-1.3,0.9-1.1,1.4c0.2,0.5,0.9,0.7,1.7,0.5
		C393.6,697.1,394.1,696.5,393.9,696z"
        />
        <path
          fill={colour9}
          d="M372.6,697.7c0-0.5-0.4-1-1-1c-0.6,0-1.1,0.4-1.1,0.9c0,0.5,0.4,1,1,1C372,698.7,372.5,698.3,372.6,697.7z"
        />
        <path
          fill={colour9}
          d="M429.7,710.1c-0.2-0.5-0.9-0.7-1.7-0.5c-0.8,0.3-1.3,0.9-1.1,1.4c0.2,0.5,0.9,0.7,1.7,0.5
		C429.3,711.2,429.8,710.6,429.7,710.1z"
        />
        <path
          fill={colour9}
          d="M439.2,691.8c-0.2-0.7-1.2-1.1-2.2-0.7c-1,0.3-1.6,1.2-1.3,1.9c0.2,0.7,1.2,1.1,2.2,0.7
		C438.9,693.4,439.5,692.5,439.2,691.8z"
        />
        <path
          fill={colour14}
          d="M425.3,665.8c0-0.5-0.6-1-1.4-1c-0.8,0-1.5,0.4-1.5,0.9c0,0.5,0.6,1,1.4,1
		C424.6,666.7,425.3,666.3,425.3,665.8z"
        />
        <path
          fill={colour14}
          d="M437.9,666.8c0.2-0.5-0.2-1.2-1-1.5c-0.7-0.3-1.5-0.2-1.7,0.3c-0.2,0.5,0.2,1.2,1,1.5
		C436.9,667.5,437.7,667.3,437.9,666.8z"
        />
        <path
          fill={colour8}
          d="M358.3,701c9.7,24,29.5,32.3,26.8,37.7C379,751.1,356.7,720.8,358.3,701z"
        />
        <path
          fill={colour8}
          d="M422.6,755.8c-10.2,3-22.7-3.3-17.7-11.1c5-7.8,35.1-10.6,42.3-36.1C447.2,708.5,450.7,747.5,422.6,755.8z"
        />
        <path
          fill={colour9}
          d="M430.4,747.7c-0.3-0.9-1.6-1.2-2.9-0.8c-1.3,0.4-2.1,1.5-1.9,2.3c0.3,0.9,1.6,1.2,2.9,0.8
		C429.8,749.6,430.7,748.6,430.4,747.7z"
        />
        <path
          fill={colour10}
          d="M414.6,755.7c-0.3-0.9-1.3-1.3-2.2-1c-0.9,0.3-1.5,1.3-1.2,2.1c0.3,0.9,1.3,1.3,2.2,1
		C414.4,757.5,414.9,756.6,414.6,755.7z"
        />
        <path
          fill={colour10}
          d="M402.2,754.4c-0.2-0.6-1-0.9-1.8-0.7c-0.8,0.3-1.2,1-1,1.6c0.2,0.6,1,0.9,1.8,0.7
		C402,755.8,402.4,755.1,402.2,754.4z"
        />
        <path
          fill={colour10}
          d="M433.9,735.6c-0.4-0.5-1.3-0.5-1.9,0.1c-0.7,0.5-0.8,1.4-0.4,1.9c0.4,0.5,1.3,0.5,1.9-0.1
		C434.2,737,434.3,736.1,433.9,735.6z"
        />
        <path
          fill={colour10}
          d="M420.2,745.2c-0.4-0.5-1.3-0.5-1.9,0.1c-0.7,0.5-0.8,1.4-0.4,1.9c0.4,0.5,1.3,0.5,1.9-0.1
		C420.5,746.6,420.7,745.7,420.2,745.2z"
        />
        <path
          fill={colour10}
          d="M427.7,723c-0.4-0.5-1.3-0.5-1.9,0.1c-0.7,0.5-0.8,1.4-0.4,1.9c0.4,0.5,1.3,0.5,1.9-0.1
		C427.9,724.3,428.1,723.5,427.7,723z"
        />
        <path
          fill={colour10}
          d="M375.9,728.5c-0.4-0.5-1.3-0.5-1.9,0.1c-0.7,0.5-0.8,1.4-0.4,1.9c0.4,0.5,1.3,0.5,1.9-0.1
		C376.1,729.9,376.3,729,375.9,728.5z"
        />
        <path
          fill={colour15}
          d="M432.4,540.1c-7.9,2.1-17.8,6.2-10.8,11.6c7,5.4,35.3,13.6,34.7,9.6C453.9,543.8,437.3,538.8,432.4,540.1z"
        />
        <path
          fill={colour15}
          d="M371.2,533c-15.1,0.3-22.3,17.5-22.3,21.5c0,4,32.4-4.4,37.8-11.3C390.5,538.2,380.3,532.8,371.2,533z"
        />
        <path
          fill={colour5}
          d="M393.2,614.5c15.4-2.8-1.5,24.8,10.1,25.5c16.5,1.1-5.6-30.5,14.4-23.7c0,0-5.4-7.7-16-8.3
		C391.2,607.3,393.2,614.5,393.2,614.5z"
        />
        <path
          fill={colour4}
          d="M398.9,586.5c-0.2,0-0.3-0.2-0.3-0.4c0-0.2,0.1-0.3,0.3-0.4c2.4-0.8,3.7-3.8,3.7-8.1c0,0,0.4,5.5,2.5,7.4
		c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.2,0.5-0.4,0.6c-0.7,0.4-1.8,0.9-2.9,0.8C400.9,587.1,399.8,586.8,398.9,586.5z"
        />
        <path
          fill={colour4}
          d="M424.7,587.5c1.2,0.1,1.5,0,1.7-1c0.2-1,0.8,1.6,1.7,2C428.2,588.5,425.6,589,424.7,587.5z"
        />
        <path
          fill={colour4}
          d="M378.7,588.4c1.1-0.4,1.5-1.1,1.9-2c0.4-1.1,0.7,1.5,1.7,1.5C382.3,587.8,380.1,589.4,378.7,588.4z"
        />
        <polygon fill={colour13} points="401.9,569 402.7,574.5 403.3,569.2 	" />
        <polygon fill={colour13} points="425.2,573.3 426,578.8 426.6,573.5 	" />
        <polygon fill={colour13} points="373.6,574.9 374.4,580.4 375,575.1 	" />
        <path
          fill={colour15}
          d="M353.2,559.1c-1.4,2.4-4.5,3.8-5.7,2.1c-0.4-0.5,0.2-2.7,1-3.2C350.9,556.5,354.5,557,353.2,559.1z"
        />
      </g>
    </>
  );
};

export default Mouth_10;
